angular.module('bmsApp.settings')
	.controller('ReminderTemplateCtrl', ReminderTemplateCtrl);

ReminderTemplateCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'notify',
	'LicenseOptionsSvc',
	'CustomerReminderTemplateSvc',
	'TextInsert',
	'InstanceSvc',
];

function ReminderTemplateCtrl($scope, $state, $q, notify, LicenseOptionsSvc, CustomerReminderTemplateSvc, TextInsert, InstanceSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
		templatePlaceholders: {
			upcomingVisit:[
				{
					value: '[Visit Date]',
					label: 'Visit Date',
				},
			],
			overdueInvoice:[
				{
					value: '[Outstanding Invoices]',
					label: 'Outstanding Invoices',
				},
				{
					value: '[Customer Balance]',
					label: 'Customer Balance',
				},
			],
			treatmentPlan:[
				{
					value: '[Formal addressee name]',
					label: 'Formal addressee name',
				},
				{
					value: '[Price (Gross)]',
					label: 'Price (Gross)',
				},
				{
					value: '[Invoice payment method]',
					label: 'Invoice payment method',
				},
			],
		}
	});

	if(InstanceSvc.instance.isTG()){
		let tgPlaceholders = [
			'Salutation',
			'First name',
			'Last name',
			'Address',
			'Treatments',
			'Job Ref.',
			'Outstanding invoice list',
		];
		angular.forEach(tgPlaceholders, function (placeholder){
			self.templatePlaceholders.upcomingVisit.push({
				value: '['+placeholder+']',
				label: placeholder,
			});
			self.templatePlaceholders.overdueInvoice.push({
				value: '['+placeholder+']',
				label: placeholder,
			});
			self.templatePlaceholders.treatmentPlan.push({
				value: '['+placeholder+']',
				label: placeholder,
			});
		});
	}

	this.$onInit = () => {
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
					initForm();
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});
	};

	function initForm() {
		self.form = {
			upcoming_visit: {
				enabled: false,
				email: {
					message: '',
				},
				sms: {
					message: '',
				},
			},
			overdue_invoices: {
				enabled: false,
				email: {
					message: '',
				},
				sms: {
					message: '',
				},
			},
			treatment_plan: {
				enabled: false,
				email: {
					message: '',
				},
				sms: {
					message: '',
				},
			},
		};

	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.insertPlaceholder = (el, text) => {
		TextInsert.insert(document.getElementById(el), text);
	};

	handlers.showPreview = (obj) => {
		let message = obj.message;
		console.log(obj);
		message = message.replace(/\[Visit Date\]/g, 'Sunday 1st January');
		message = message.replace(/\[Outstanding Invoices]/g, '2');
		message = message.replace(/\[Customer Balance]/g, '£100');
		message = message.replace(/\[Salutation]/g, 'Mrs');
		message = message.replace(/\[First name]/g, 'Pamela');
		message = message.replace(/\[Last name]/g, 'Campbell');
		message = message.replace(/\[Address]/g, 'The Ivy, RUE DU CLOSEL, GY3 5ES');
		message = message.replace(/\[Treatments]/g, 'Moss Control,  Weed Control');
		message = message.replace(/\[Formal addressee name]/g, 'Mrs Pamela Campbell');
		message = message.replace(/\[Price \(Gross\)]/g, '£100');
		message = message.replace(/\[Invoice payment method]/g, 'After each visit');
		message = message.replace(/\[Job Ref.]/g, '#394');
		message = message.replace(/\[Outstanding invoice list]/g, '£17.67 -  T151/14973\n£48.00 -  T151/14974\n£79.50 -  T151/14975\n');

		angular.extend(obj, {
			preview: message,
		});
	};

	handlers.licenseChanged = () => {
		initForm();
		CustomerReminderTemplateSvc.read(self.license.id)
			.then((response) => {
				self.templates = response.data.templates;

				angular.forEach(self.templates, (template) => {
					if (template.type === 'upcoming_visit') {
						self.form.upcoming_visit.enabled = true;
						self.form.upcoming_visit.email.message = template.email_message;
						self.form.upcoming_visit.sms.message = template.sms_message;
						handlers.showPreview(self.form.upcoming_visit.email);
						handlers.showPreview(self.form.upcoming_visit.sms);
					}
					if (template.type === 'overdue_invoices') {
						self.form.overdue_invoices.enabled = true;
						self.form.overdue_invoices.email.message = template.email_message;
						self.form.overdue_invoices.sms.message = template.sms_message;
						handlers.showPreview(self.form.overdue_invoices.email);
						handlers.showPreview(self.form.overdue_invoices.sms);
					}
					if (template.type === 'treatment_plan') {
						self.form.treatment_plan.enabled = true;
						self.form.treatment_plan.email.message = template.email_message;
						self.form.treatment_plan.sms.message = template.sms_message;
						self.form.treatment_plan.email_signature_enabled = template.email_signature_enabled;

						handlers.showPreview(self.form.treatment_plan.email);
						handlers.showPreview(self.form.treatment_plan.sms);
					}
				});

			});
	};

	handlers.submitClick = function () {
		angular.extend(self.form, {
			licenceId: self.license.id,
		});

		CustomerReminderTemplateSvc.save(self.form).then((response) => {
			notify({
				message: 'Templates successfully saved'
			});
		});
	};
}
